import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import liquorIcon from "../assets/category-icons/liquor.png";

const NEXT_AFTER_LOGIN = "/start";
const APP_DOWNLOAD_URL = "/download";

export default function Hero() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const primaryLabel = user ? "결제등록" : "무료로 시작하기";

  const goPrimary = () => {
    if (user) return navigate("/start");
    return navigate(`/login?next=${encodeURIComponent(NEXT_AFTER_LOGIN)}`);
  };

  const goDownload = () => {
    if (APP_DOWNLOAD_URL.startsWith("http")) {
      window.open(APP_DOWNLOAD_URL, "_blank", "noopener,noreferrer");
      return;
    }
    navigate(APP_DOWNLOAD_URL);
  };

  return (
    <section className="bg-transparent">
      <div className="hidden md:block">
        <div className="mx-auto w-full py-0">
          <div
            className="
              relative overflow-hidden
              bg-[linear-gradient(180deg,#fff6ec_0%,#ffe9cf_40%,#fff3e4_100%)]
            "
          >
            <div className="pointer-events-none absolute inset-0">
              <div className="absolute left-[-120px] top-[-40px] h-[320px] w-[320px] rounded-full bg-[#ff8a1f]/22 blur-3xl" />
              <div className="absolute right-[-80px] top-[50px] h-[260px] w-[260px] rounded-full bg-[#f97316]/18 blur-3xl" />
              <div className="absolute bottom-[-120px] left-[18%] h-[280px] w-[280px] rounded-full bg-[#fed7aa]/55 blur-3xl" />

              <div className="absolute left-[max(24px,6vw)] top-[74px] hidden rounded-[30px] border border-white/70 bg-white/72 px-5 py-3 shadow-[0_18px_40px_rgba(143,69,8,.12)] backdrop-blur">
                <div className="flex items-center gap-3">
                  <img src={liquorIcon} alt="" aria-hidden="true" className="h-10 w-10 rounded-2xl object-cover" />
                  <div>
                    <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#d76d17]">
                      JULYU PAY
                    </div>
                    <div className="text-sm font-extrabold text-slate-900">
                      주류 대금 카드결제
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute right-[max(28px,7vw)] top-[82px] hidden rounded-[28px] border border-white/70 bg-white/78 px-4 py-3 shadow-[0_18px_40px_rgba(143,69,8,.10)] backdrop-blur">
                <div className="text-[11px] font-semibold text-slate-500">진행 상태</div>
                <div className="mt-1 flex items-center gap-2">
                  <span className="rounded-full bg-[#fff7ed] px-2.5 py-1 text-[11px] font-bold text-[#c2410c]">
                    승인대기
                  </span>
                  <span className="text-xs font-semibold text-slate-900">서류 검토 후 결제 진행</span>
                </div>
              </div>
            </div>

            <div className="relative mx-auto flex min-h-[460px] max-w-6xl items-center px-10 py-12 lg:min-h-[560px] lg:px-16">
              <div className="grid w-full items-center gap-10 lg:grid-cols-1">
                <div className="max-w-2xl">
                  <h1
                    className="
                      font-extrabold leading-[1.15] text-slate-900
                      text-[clamp(32px,4vw,50px)]
                    "
                  >
                    주류 대금 납부,
                    <br />
                    <span className="whitespace-nowrap text-[#d96f16]">이제 현금 대신 일반 신용카드로 가능합니다.</span>
                  </h1>

                  <div className="mt-8 flex flex-wrap items-center gap-4">
                    <button
                      onClick={goPrimary}
                      className="
                        inline-flex items-center justify-center
                        rounded-2xl bg-[#f97316]
                        px-7 py-3
                        text-sm font-semibold text-white sm:text-base
                        shadow-[0_10px_24px_rgba(242,117,31,.30)]
                        transition hover:brightness-110 active:translate-y-px
                      "
                    >
                      {primaryLabel}
                    </button>

                    <button
                      type="button"
                      onClick={goDownload}
                      className="
                        inline-flex items-center justify-center
                        rounded-2xl border border-[#f97316]/45
                        bg-white/78
                        px-7 py-3
                        text-sm font-semibold text-[#c2410c] sm:text-base
                        shadow-[0_10px_20px_rgba(176,94,23,.12)]
                        backdrop-blur transition
                        hover:bg-white hover:border-[#f97316]/65
                        active:translate-y-px
                      "
                    >
                      어플 다운로드
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="md:hidden bg-[#fff7ee]">
        <div className="w-full px-5 pb-8 pt-8">
          <div className="overflow-hidden rounded-[30px] bg-[linear-gradient(180deg,#fff7ed_0%,#fed7aa_42%,#fff7ed_100%)] px-5 pb-6 pt-6 shadow-[0_18px_45px_rgba(143,69,8,.12)]">
            <h1 className="text-[24px] font-extrabold leading-snug text-slate-900">
              주류/음료 대금 결제가 필요할 땐
              <br />
              주류페이로 카드결제하세요.
            </h1>

            <div className="mt-5 flex flex-col gap-3">
              <button
                onClick={goPrimary}
                className="w-full rounded-2xl bg-[#f97316] py-3 text-sm font-semibold text-white shadow-[0_10px_24px_rgba(242,117,31,.28)] transition hover:brightness-110 active:translate-y-px"
              >
                {primaryLabel}
              </button>

              <button
                type="button"
                onClick={goDownload}
                className="w-full rounded-2xl border border-[#f97316]/40 bg-white/85 py-3 text-sm font-semibold text-[#c2410c] shadow-[0_10px_22px_rgba(143,69,8,.10)] transition hover:bg-white active:translate-y-px"
              >
                어플 다운로드
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
